// Disponibilidade dos padrões (tecidos), gerida à mão pela Alexandra. Sem stock numérico: só um estado.
// JavaScript puro, sem dependências: é usado pela loja e pelo Worker (validação da encomenda), para as regras serem uma só.
// Forma pública de um padrão no catálogo: { name, texture, availability?, extraDays?: { min, max }, availabilityNote? }.
// Sem `availability` (padrões antigos), o padrão está disponível.

export const PATTERN_STATES = ["disponivel", "por-encomenda", "esgotado"];

export const patternState = (p) => (PATTERN_STATES.includes(p?.availability) ? p.availability : "disponivel");
export const isSoldOut = (p) => patternState(p) === "esgotado";
export const isOnOrder = (p) => patternState(p) === "por-encomenda";

export const daysText = (min, max) => {
  const unit = (n) => (n === 1 ? "dia útil" : "dias úteis");
  return min === max ? `${min} ${unit(min)}` : `${min} a ${max} dias úteis`;
};

// Acréscimo de prazo deste padrão (só vale "por encomenda"), ou null quando a Alexandra só deixou uma mensagem.
export const extraOf = (p) => (isOnOrder(p) && Number.isInteger(p?.extraDays?.min) && Number.isInteger(p?.extraDays?.max) ? { min: p.extraDays.min, max: p.extraDays.max } : null);

// Frase curta para o cliente, ao escolher o padrão.
export const onOrderMessage = (p) => {
  const extra = extraOf(p);
  const base = extra ? `Por encomenda: pode acrescentar ${daysText(extra.min, extra.max)} ao prazo de preparação.` : "Por encomenda: o prazo pode ser superior ao habitual.";
  return p?.availabilityNote ? `${base} ${p.availabilityNote}` : base;
};

/**
 * Efeito dos padrões escolhidos numa encomenda no prazo. Regra única e previsível: o acréscimo da encomenda é o MAIOR
 * dos acréscimos dos padrões "por encomenda" (a espera pelo tecido corre em paralelo, não se soma).
 * Devolve null sem padrões por encomenda; `unknown` = há padrões por encomenda sem prazo definido (a Alexandra confirma).
 */
export const combineExtras = (patterns) => {
  const onOrder = [];
  const seen = new Set();
  for (const p of patterns) {
    if (!isOnOrder(p) || seen.has(p.name)) continue;
    seen.add(p.name);
    onOrder.push(p);
  }
  if (!onOrder.length) return null;
  const withDays = onOrder.map(extraOf).filter(Boolean);
  const min = withDays.length ? Math.max(...withDays.map((e) => e.min)) : null;
  const max = withDays.length ? Math.max(...withDays.map((e) => e.max)) : null;
  return {
    min, max, text: min === null ? null : daysText(min, max),
    unknown: withDays.length < onOrder.length,
    patterns: onOrder.map((p) => p.name),
  };
};

// Prazo geral da loja + acréscimo. Só soma quando os dois têm dias; senão devolve null (mostra-se cada parte à parte).
export const totalLeadTime = (lt, extra) =>
  lt?.configured && extra && extra.min !== null
    ? { minDays: lt.minDays + extra.min, maxDays: lt.maxDays + extra.max, text: daysText(lt.minDays + extra.min, lt.maxDays + extra.max) }
    : null;
